import firebase, { storage } from './firebase';
import URL from 'url-parse';

export const uploadFile = (file: File, path: String, metadata = {}) => {
  const ref = storage.ref(path).child(file.name);

  return ref.put(file, metadata).then(
    async uploadTaskSnapshot => {
      console.log('uploadTaskSnapshot', uploadTaskSnapshot);
      if (uploadTaskSnapshot) {
        const url = await uploadTaskSnapshot.ref.getDownloadURL();
        console.log('url = ', url);
        return url;
      }
    }, e => {
      console.log('e = ', e);
      console.error('failed to put file on storage: ', e);
    });
}

export const getFirebaseStorgeFilenameFromURL = (url) => {
  const urlObj = new URL(url);
  const components = urlObj.pathname.split('%2F');
  console.log('components = ', components);
  console.log(components.map(c => decodeURI(c)));
  const filename = components.length > 1 ? decodeURI(components[components.length - 1]) : decodeURI(components[0]);
  console.log('filename = ', filename);
  return filename;
}